/** Ciclo actual ou posterior (ciclos fechados são só leitura). */
export function isEditableSelfieCycle(cycle, _selfieDayOfMonth, _today = new Date()) {
  if (!cycle?.start) return false;
  return Boolean(cycle.isCurrent);
}

/** Data (ISO) no ciclo actual em aberto. */
export function isEditableOccurrenceDate(isoDate, _selfieDayOfMonth, today = new Date(), cycles = []) {
  if (!isoDate) return false;
  const current = cycles.find((c) => c.isCurrent);
  if (!current) return true;
  return isoDate >= current.start && isoDate <= current.end;
}

/** @deprecated Calendário anual — usa intersect com ciclo actual. */
export function isEditableExpenseMonth(year, month, _selfieDayOfMonth, today = new Date(), cycles = []) {
  const current = cycles.find((c) => c.isCurrent);
  if (!current) return true;
  const monthStart = `${year}-${String(month).padStart(2, '0')}-01`;
  return monthStart >= current.start;
}

export function isEditableAnnualMonth(year, month, selfieDayOfMonth, today = new Date(), cycles = []) {
  const refYear = today.getFullYear();
  if (year < refYear) return false;
  if (year > refYear) return true;
  return isEditableExpenseMonth(year, month, selfieDayOfMonth, today, cycles);
}
